import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';
import { isEmpty } from 'lodash';

import { Report, ListTransfer } from '~/components';
import { DateTime, Autocomplete, RadioGroup } from '~/components/Form';

import * as Yup from 'yup';
import { parseDateString, t } from '~/helpers';

function Relconsumocombustivelperiodo() {
  const [open, setOpen] = useState(true);

  const [valueProduto, setValueProduto] = React.useState(0);
  const [inputValueProduto, setInputValueProduto] = React.useState('');

  const [orgaos, setOrgaos] = useState([]);

  const cells = useMemo(() => [
    { id: 'orga_nome', label: 'Órgão' },
    { id: 'orga_codigo', label: 'Código'}
  ], []);

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const handleValidate = useCallback(async (data) => {
    try {
      const schema = Yup.object().shape({
        datahorainicial: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio')),
        datahorafinal: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(datahorafinal, `Não pode ser superior à ${datahorafinal}`)
          .min(
            Yup.ref('datahorainicial'),
            'Não pode ser inferior à data inicial'
          ),
        prod_codigo: Yup.string().nullable(),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      if (isEmpty(orgaos))
        throw 'Por favor, selecione ao menos um órgão antes de enviar.';
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      } else {
        throw err;
      }
    }
  }, [orgaos]);

  function handleSerializeForm(params) {
    const { datahorainicial, datahorafinal } = params;

    let produto = '';

    if (params.prod_codigo) {
      produto = params.prod_codigo;
    }

    let produtostr = '';

    if (params.prod_descricao) {
      produtostr = params.prod_descricao;
    }

    let codigos = [];

    orgaos.map((orgao) => {
      codigos.push(orgao.orga_codigo);
    })

    let orgao = codigos;

    let tipo = 'pdf';

    if (params.formato) {
      tipo = params.formato;
    }

    return {
      ...params,
      datahorainicial,
      datahorafinal,
      produto,
      produtostr,
      orgao,
      tipo,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title="Consumo de Combustível por Período"
      relatorio="consumocombustivelperiodo"
      maxWidth="md"
      validate={(param) => handleValidate(param)}
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial,
        datahorafinal,
      }}
    >
      <DateTime time label="Data Inicial" name="datahorainicial" />

      <DateTime time label="Data Final" name="datahorafinal" />

      <Autocomplete
        name="prod_codigo"
        label="prod_descricao"
        title="Produto"
        id="prod_codigo"
        url="produtos"
        unique="prod_codigo"
        value={valueProduto}
        inputValue={inputValueProduto}
        onChange={(event, newValue) => {
          setValueProduto(newValue);
        }}
        onInputChange={(event, newInputValueProtudo) => {
          setInputValueProduto(newInputValueProtudo);
        }}
        defaultValue=""
        hiddens={[{ name: 'prod_descricao' }]}
        getValue={(value) => {
          if (value.prod_codigo !== null) {
            setValueProduto(value.prod_codigo);
          } else {
            setValueProduto(0);
          }
        }}
      />

      <ListTransfer
        search
        grid
        cells={cells}
        url="orgaos"
        label="orga_nome"
        unique="orga_codigo"
        leftTitle="Órgãos disponíveis"
        rightTitle="Órgãos selecionadas"
        onCallback={(value) => setOrgaos(value)}
        maxWidth={38}
        maxHeight={200}
        reset={isEmpty(orgaos)}
        showCount
      />

      <RadioGroup
        name="formato"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relconsumocombustivelperiodo;
